/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles show a published date and an updated date that only changes when the content itself changes.`)
};

const es_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los artículos muestran una fecha de publicación y una fecha de actualización que solo cambia cuando el contenido en sí cambia.`)
};

const de_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel zeigen ein Veröffentlichungsdatum und ein Aktualisierungsdatum, das sich nur ändert, wenn sich der Inhalt selbst ändert.`)
};

const nl_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikelen tonen een publicatiedatum en een bijgewerkte datum die alleen verandert wanneer de inhoud zelf verandert.`)
};

const fr_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les articles affichent une date de publication et une date de mise à jour qui ne change que lorsque le contenu lui-même change.`)
};

const it_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli articoli mostrano una data di pubblicazione e una data di aggiornamento che cambia solo quando il contenuto stesso cambia.`)
};

const pt_br2_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os artigos mostram uma data de publicação e uma data de atualização que só muda quando o próprio conteúdo muda.`)
};

const pt_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os artigos mostram uma data de publicação e uma data de atualização que só muda quando o próprio conteúdo muda.`)
};

const ja_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記事には公開日と更新日が表示され、更新日はコンテンツ自体が変更された場合にのみ変わります。`)
};

const zh_about_verify_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章会显示发布日期和更新日期，更新日期只有在内容本身发生变化时才会改变。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_verify_li4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_verify_li4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_verify_li4", locale)
	if (locale === "en") return en_about_verify_li4(inputs)
	if (locale === "es") return es_about_verify_li4(inputs)
	if (locale === "de") return de_about_verify_li4(inputs)
	if (locale === "nl") return nl_about_verify_li4(inputs)
	if (locale === "fr") return fr_about_verify_li4(inputs)
	if (locale === "it") return it_about_verify_li4(inputs)
	if (locale === "pt-BR") return pt_br2_about_verify_li4(inputs)
	if (locale === "pt") return pt_about_verify_li4(inputs)
	if (locale === "ja") return ja_about_verify_li4(inputs)
	return zh_about_verify_li4(inputs)
};